/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EnquadramentoTransportadoraCriteriaDto } from '../models/enquadramento-transportadora-criteria-dto';
import { EnquadramentoTransportadoraDto } from '../models/enquadramento-transportadora-dto';
import { EnquadramentoTransportadoraFormDto } from '../models/enquadramento-transportadora-form-dto';
import { EnquadramentoTransportadoraPageDto } from '../models/enquadramento-transportadora-page-dto';


/**
 * Enquadramentos Entidade Transportadora
 */
@Injectable({
  providedIn: 'root',
})
export class EnquadramentoTransportadoraService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getEnquadramentosTransportadora
   */
  static readonly GetEnquadramentosTransportadoraPath = '/enquadramentos-transportadora';

  /**
   * Pesquisar Transportadoras.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnquadramentosTransportadora()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnquadramentosTransportadora$Response(params?: {
    criteria?: EnquadramentoTransportadoraCriteriaDto;
  }): Observable<StrictHttpResponse<EnquadramentoTransportadoraPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, EnquadramentoTransportadoraService.GetEnquadramentosTransportadoraPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnquadramentoTransportadoraPageDto>;
      })
    );
  }

  /**
   * Pesquisar Transportadoras.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEnquadramentosTransportadora$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnquadramentosTransportadora(params?: {
    criteria?: EnquadramentoTransportadoraCriteriaDto;
  }): Observable<EnquadramentoTransportadoraPageDto> {

    return this.getEnquadramentosTransportadora$Response(params).pipe(
      map((r: StrictHttpResponse<EnquadramentoTransportadoraPageDto>) => r.body as EnquadramentoTransportadoraPageDto)
    );
  }

  /**
   * Path part for operation submeterEnquadramentoTransportadora
   */
  static readonly SubmeterEnquadramentoTransportadoraPath = '/enquadramentos-transportadora';

  /**
   * Submeter um pedido de Enquadramento de Entidade Transportadora.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterEnquadramentoTransportadora()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterEnquadramentoTransportadora$Response(params?: {
    body?: {
'submeterTransportadoraForm'?: EnquadramentoTransportadoraFormDto;
'comprovativosCertC7'?: Array<Blob>;
'comprovativosCertFormacao'?: Array<Blob>;
}
  }): Observable<StrictHttpResponse<EnquadramentoTransportadoraDto>> {

    const rb = new RequestBuilder(this.rootUrl, EnquadramentoTransportadoraService.SubmeterEnquadramentoTransportadoraPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnquadramentoTransportadoraDto>;
      })
    );
  }

  /**
   * Submeter um pedido de Enquadramento de Entidade Transportadora.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterEnquadramentoTransportadora$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterEnquadramentoTransportadora(params?: {
    body?: {
'submeterTransportadoraForm'?: EnquadramentoTransportadoraFormDto;
'comprovativosCertC7'?: Array<Blob>;
'comprovativosCertFormacao'?: Array<Blob>;
}
  }): Observable<EnquadramentoTransportadoraDto> {

    return this.submeterEnquadramentoTransportadora$Response(params).pipe(
      map((r: StrictHttpResponse<EnquadramentoTransportadoraDto>) => r.body as EnquadramentoTransportadoraDto)
    );
  }

  /**
   * Path part for operation getEnquadramentoTransportadora
   */
  static readonly GetEnquadramentoTransportadoraPath = '/enquadramentos-transportadora/{id}';

  /**
   * Pesquisar Transportadoras por Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnquadramentoTransportadora()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnquadramentoTransportadora$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<EnquadramentoTransportadoraDto>> {

    const rb = new RequestBuilder(this.rootUrl, EnquadramentoTransportadoraService.GetEnquadramentoTransportadoraPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnquadramentoTransportadoraDto>;
      })
    );
  }

  /**
   * Pesquisar Transportadoras por Id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEnquadramentoTransportadora$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnquadramentoTransportadora(params: {
    id: number;
  }): Observable<EnquadramentoTransportadoraDto> {

    return this.getEnquadramentoTransportadora$Response(params).pipe(
      map((r: StrictHttpResponse<EnquadramentoTransportadoraDto>) => r.body as EnquadramentoTransportadoraDto)
    );
  }

}
